const photosUploadSteps = [
  {
    title: "Foto 1",
    description: "Ärzt:innen-Formular",
  },
  {
    title: "Foto 2",
    description: "(fakultativ)",
  },
  {
    title: "Foto 3",
    description: "(fakultativ)",
  },
]

export { photosUploadSteps }
